import { generateActions } from "utils/generateActions";

export const GET_TABLE_COMPANIES = generateActions("GET_TABLE_COMPANIES");
export const UPLOAD_COMPANIES = generateActions("UPLOAD_COMPANIES");